import { Link } from 'react-router-dom';
import HeroCarousel from './components/HeroCarousel';
import CategoryEntry from './components/CategoryEntry';
import TvRankList from './components/TvRankList';
import NewsSpotlight from './components/NewsSpotlight';
import MediaGrid from '@/components/feature/MediaGrid';
import SectionTitle from '@/components/feature/SectionTitle';
import { getMediaByType } from '@/lib/media';
import { newsList } from '@/mocks/news';

export default function Home() {
  const latestMovies = [...getMediaByType('movie')]
    .sort((a, b) => b.year - a.year || b.rating - a.rating)
    .slice(0, 6);

  const hotTvs = [...getMediaByType('tv')]
    .sort((a, b) => b.rating - a.rating)
    .slice(0, 6);

  const news = newsList.slice(0, 5);

  return (
    <div className="w-full">
      <HeroCarousel />

      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        {/* 分类快捷入口 */}
        <section className="-mt-10 relative z-20 md:-mt-14">
          <CategoryEntry />
        </section>

        {/* 最新电影推荐 */}
        <section className="pt-12 md:pt-16">
          <SectionTitle
            title="最新电影推荐"
            subtitle="近期上线的热门与高分电影"
            moreTo="/category/movie"
          />
          <MediaGrid items={latestMovies} columns="grid-cols-2 sm:grid-cols-3 lg:grid-cols-6" />
        </section>

        {/* 热门电视剧推荐 */}
        <section className="pt-12 md:pt-16">
          <SectionTitle
            title="热门电视剧推荐"
            subtitle="按播放热度与评分精选的热播剧集"
            moreTo="/category/tv"
          />
          <TvRankList items={hotTvs} />
        </section>
      </div>

      {/* 精选影视资讯 */}
      <section className="mt-12 w-full bg-background-100 py-12 md:mt-16 md:py-16">
        <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
          <SectionTitle
            title="精选影视资讯"
            subtitle="行业动态、影评解读与影视幕后"
            moreTo="/news"
          />
          <NewsSpotlight items={news} />
        </div>
      </section>

      {/* 网站简介 */}
      <section className="w-full py-12 md:py-16">
        <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
          <div className="grid grid-cols-1 items-center gap-8 rounded-lg bg-primary-950 p-6 md:grid-cols-2 md:p-10">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-primary-900 px-3 py-1 text-xs font-medium text-secondary-400">
                <i className="ri-film-line" />
                关于八戒影院
              </span>
              <h2 className="mt-4 text-2xl font-bold text-background-50 font-heading md:text-3xl">
                一站式的影视浏览与资讯平台
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-background-300 md:text-base">
                八戒影院致力于为用户提供最新电影、电视剧等多种影视内容，涵盖科幻、悬疑、爱情、动作等多样类型和题材。
                你可以按类型、地区、年份与播放状态快速筛选，也可以通过模糊搜索直达感兴趣的作品与影视资讯，享受便捷流畅的浏览体验。
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Link
                  to="/category/movie"
                  className="flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
                >
                  <i className="ri-film-line text-lg" />
                  浏览电影
                </Link>
                <Link
                  to="/category/tv"
                  className="flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50/10 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/20"
                >
                  <i className="ri-tv-2-line text-lg" />
                  浏览电视剧
                </Link>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-3">
              {[
                { icon: 'ri-movie-2-line', value: '1500+', label: '影视作品' },
                { icon: 'ri-tv-2-line', value: '600+', label: '剧集资源' },
                { icon: 'ri-newspaper-line', value: '300+', label: '影视资讯' },
              ].map((stat) => (
                <div key={stat.label} className="rounded-lg bg-primary-900 p-4 text-center">
                  <i className={`${stat.icon} text-2xl text-accent-400`} />
                  <p className="mt-2 text-xl font-bold text-background-50 font-heading">{stat.value}</p>
                  <p className="mt-1 text-xs text-background-400">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}